export default "__VITE_ASSET__BC1OUi0d__"